
<template>
  <div>
    <div class="row mb-4">
      <div role="group" aria-labelledby="label" class="col-12">
        <div id="label" class="label">{{ schema.actionType.$title }}</div>

        <div>
          <w-radio :model="schema.actionType" :value="1">Wydanie zaświadczenia</w-radio>

          <w-radio :model="schema.actionType" :value="2">Korekta zaświadczenia</w-radio>
        </div>
      </div>
    </div>

    <div class="row">
      <w-input class="col-4" :model="schema.exchangeRate" />
    </div>

    <div class="row">
      <w-input class="col-6" :model="schema.numberOfCertificate" />

      <w-datepicker class="col-6" :model="schema.certificateDate" />
    </div>

    <div class="row">
      <w-input class="col-4" :model="schema.firstName" />

      <w-input class="col-4" :model="schema.lastName" />

      <w-input class="col-4" :model="schema.position" />
    </div>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

export default {
  components,
  props: {
    schema: { type: Object, required: false }
  }
};
</script>